// Copyright (c) 2022 by Move Closer

import {
  FilterParamConfig,
  IRelatedService,
  ModuleContentResolver,
  NavigationItem,
  PossibleRelatedType,
  ProductSneakPeakData, ResolvedBannerData
} from '../../contexts'
import { logger } from '../../support'

import { resolveBanners, resolveFilters, resolveNavigation, resolveProducts } from '../resolvers'

import { ProductsListModuleContent, ProductsListModuleContentInput } from './ProductsList.contracts'

/**
 * @author Agnieszka Zawadzka <agnieszka.zawadzka@movecloser.pl>
 */
export const resolveProductsListModuleContent: ModuleContentResolver<ProductsListModuleContentInput, ProductsListModuleContent> =
  async (
    input: ProductsListModuleContentInput,
    relatedService: IRelatedService
  ): Promise<ProductsListModuleContent> => {
    let defaultPerPage: number = 16
    let defaultSort: string = ''
    let banners: ResolvedBannerData[] | undefined
    let categoryNav: NavigationItem[] | null = null
    let filters: FilterParamConfig[] | undefined
    let products: ProductSneakPeakData[] = []
    let total: number = 0

    /**
     * Resolve mainNav for handling category filters
     */
    try {
      const unresolvedCategoryNav = input.categoryNav ? input.categoryNav : { type: PossibleRelatedType.Navigation, value: 1 }
      categoryNav = await resolveNavigation(unresolvedCategoryNav, relatedService)
    } catch (e) {
      logger(e, 'warn')
    }

    try {
      products = input.products ? await resolveProducts(input.products, relatedService) : []
      filters = input.filters ? await resolveFilters(input.filters, relatedService) : undefined
      banners = input.banners ? await resolveBanners(input.banners, relatedService) : undefined

      if (input.products) {
        const productsDescription = await relatedService.describe(input.products)

        total = productsDescription.totalItems
        defaultPerPage = productsDescription.defaultPerPage
        defaultSort = productsDescription.defaultSort
      }
    } catch (e) {
      logger(e, 'warn')
    }

    return {
      ...input,
      banners,
      defaultPerPage,
      defaultSort,
      categoryNav,
      filters,
      products,
      total
    }
  }
